import { render, staticRenderFns } from "./QuestionnaireVideo.vue?vue&type=template&id=62e54808"
import script from "./QuestionnaireVideo.vue?vue&type=script&lang=js"
export * from "./QuestionnaireVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports